import { DaysOfWeek, FormConfig } from '@frontend/design-system';
import { AvailabilityScheduleType, BookingInterval } from '../../types/availability-rules.types';
import { TIME_UNIT_OPTIONS } from './constants';

export const availabilityRulesFields = {
  recurrence: {
    type: 'dropdown',
    required: true,
    value: AvailabilityScheduleType.WEEKLY,
  },
  interval: {
    type: 'dropdown',
    required: true,
    value: '1',
  },
  timeUnit: {
    type: 'dropdown',
    required: true,
    value: TIME_UNIT_OPTIONS[0].value,
  },
  daysOfWeek: {
    type: 'multiselect',
    value: <DaysOfWeek[]>[],
  },
  startDate: {
    type: 'date',
    value: '',
  },
  startTime: {
    type: 'time',
    required: true,
    value: '',
  },
  endTime: {
    type: 'time',
    required: true,
    value: '',
  },
  provider: {
    type: 'dropdown',
    required: true,
    value: '',
  },
  appointmentTypes: {
    type: 'checklist',
    required: true,
    minRequired: 1,
    value: [],
  },
  bookingCadence: {
    type: 'dropdown',
    required: true,
    value: BookingInterval.NONE,
  },
} satisfies FormConfig;

export type AvailabilityRulesFieldTypes = typeof availabilityRulesFields;
